// extracted by mini-css-extract-plugin
export default {"songs":"songs_songs__0sskz","mobilePagination":"songs_mobilePagination__52Uij","pagination":"songs_pagination__gj7Oe","table":"songs_table__2UaG1"};